import {useEffect, useState} from "react";
import {withRouter} from "react-router-dom";
import PageLoadingOverlay from "./PageLoadingOverlay";

const RouterPathController = ({path, history, onPush}) => {
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    if (path !== null) {
      setIsLoading(true);
      setTimeout(function () {
        history.push(path);
        setIsLoading(false);
      }, 1000); // we make sure everything is loaded and ready
      onPush();
    }
  },[path]);

  return (
    isLoading ? <PageLoadingOverlay visible={true}/> : null
  );
};

export default withRouter(RouterPathController);
